const STORAGE_KEY = "tvoy_podarok_pending_clip_action";
const MAX_AGE_MS = 60 * 60 * 1000;
export const CLIP_ACTION_ROUTES = {
    video_cover: "/video-cover",
    karaoke: "/karaoke",
    extend: "/extend-song",
};
function isType(v) {
    return v === "video_cover" || v === "karaoke" || v === "extend";
}
export function savePendingClipAction(action) {
    try {
        const payload = {
            type: action.type,
            audioId: action.audioId,
            params: action.params,
            source: action.source,
            savedAt: Date.now(),
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    }
    catch {
        /* private mode / quota */
    }
}
export function getPendingClipAction() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw)
            return null;
        const s = JSON.parse(raw);
        if (!isType(s.type))
            return null;
        const audioId = Number(s.audioId);
        if (!(Number.isFinite(audioId) && audioId > 0))
            return null;
        if (!s.params || typeof s.params !== "object")
            return null;
        const savedAt = Number(s.savedAt);
        if (Number.isFinite(savedAt) && Date.now() - savedAt > MAX_AGE_MS) {
            clearPendingClipAction();
            return null;
        }
        return {
            type: s.type,
            audioId,
            params: s.params,
            source: s.source && typeof s.source === "object" ? s.source : undefined,
            savedAt: Number.isFinite(savedAt) ? savedAt : Date.now(),
        };
    }
    catch {
        return null;
    }
}
export function clearPendingClipAction() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    }
    catch {
        /* no-op */
    }
}
export function getPendingClipResumeNavigation() {
    const action = getPendingClipAction();
    if (!action)
        return null;
    return {
        path: CLIP_ACTION_ROUTES[action.type],
        state: {
            resumeClipAction: true,
            audioId: action.audioId,
            title: action.source?.title,
            audioUrl: action.source?.audioUrl,
            imageUrl: action.source?.imageUrl,
        },
    };
}
